// VOY-485 (rebuild) — Gaming · Level (Public profile tab).
//
// PLACEHOLDER. Gaming layer (XP / levels / streaks / friends-invited /
// reviews-written / "Top 1%") not built. Style the chrome with a
// representative empty state so the section reads "coming soon."
//
// TODO: wire to gaming backend when the layer ships.

export function GamingSection() {
  return (
    <section className="card" aria-labelledby="gaming-h">
      <div className="card-h">
        <h3 id="gaming-h">Gaming &middot; Level</h3>
        <span className="meta">COMING SOON</span>
      </div>
      <div className="level-bar" aria-hidden="true"><span style={{ width: '0%' }} /></div>
      <div className="level-meta">
        <span>NOT STARTED</span>
        <span>—</span>
      </div>
      <div className="divider" />
      <div className="stack sm">
        <div className="row between"><span style={{ fontSize: 13 }}>Current streak</span><span className="num">—</span></div>
        <div className="row between"><span style={{ fontSize: 13 }}>Friends invited</span><span className="num">—</span></div>
        <div className="row between"><span style={{ fontSize: 13 }}>Reviews written</span><span className="num">—</span></div>
        <div className="row between"><span style={{ fontSize: 13 }}>Ranking</span><span className="num">—</span></div>
      </div>
      <p className="placeholder-note">Levels, points, and streaks arrive with the gaming layer.</p>
    </section>
  )
}
